import {
  foldEitherToAction,
  memoed,
  Loading,
  loadable,
  Organization,
} from '@library/react-toolkit'
import * as t from './types'
import * as api from './api'
import * as effects from 'redux-saga/effects'
import { pipe } from 'fp-ts/lib/function'
import { CancelToken } from 'axios'
import { task } from 'fp-ts'
import { State } from '../../store'
import { matchPathGuard, takeLatest, waitForOrganization } from '../../saga'
import { LocationChangeAction } from 'connected-react-router'

export const initialState: t.State = memoed.init({
  balance: {},
  userNymID: '',
})

export const reducer = (s: t.State = initialState, a: t.Actions): t.State => {
  switch (a.type) {
    case 'BALANCE/get_balance':
      return pipe(s, memoed.step(Loading))
    case 'BALANCE/get_balance_result':
      return pipe(s, memoed.step(a.payload))
    default:
      return s
  }
}

function* getBalanceSaga(_: t.GetBalanceAction, token?: CancelToken) {
  const org: Organization = yield waitForOrganization()

  // @ts-ignore
  yield yield pipe(
    api.getBalance(org.name, token),
    task.map(foldEitherToAction(t.getBalanceResult)),
    task.map(a => effects.put(a)),
    e => effects.call(e)
  )
}

export function* hasBalance() {
  const b: boolean = yield effects.select(
    (s: State) => loadable.isOk(s.balance.v) || loadable.isLoading(s.balance.v)
  )

  return b
}

function* changePageSaga(_: LocationChangeAction) {
  yield waitForOrganization()

  yield effects.put(t.getBalanceAction())
}

export function* saga() {
  yield effects.all([
    effects.takeLeading('BALANCE/get_balance', getBalanceSaga),
    takeLatest(matchPathGuard('/'), changePageSaga),
  ])
}
